/** @jsx h */
/** @jsxFrag Fragment */
import { useReducer } from "preact/hooks";
import { makeReducer } from "@uiw/utils";
import { ActionMapHandler, Message } from "@utils/types";

interface AppState {
  folders: Record<string, boolean>;
  defaultOpen: boolean;
}

const DefaultState: AppState = {
  folders: {},
  defaultOpen: false,
};

type Handlers = ActionMapHandler<Actions, AppState>;

interface Actions {
  init: undefined;
  "add/path": { path: string };
  "folder/toggle": { path: string };
  "folder/openChildren": { path: string };
  "folder/closeChildren": { path: string };
}

export interface FoldersContext {
  state: AppState;
  dispatch: (action: Message<Actions>) => void;
}

const handlers: Handlers = {
  init: ({ state }) => {
    return state;
  },
  "add/path": ({ state, payload }) => {
    if (Object.hasOwn(state.folders, payload.path)) return state;
    const newState = structuredClone(state);
    newState.folders[payload.path] = state.defaultOpen;
    return newState;
  },
  "folder/toggle": ({ state, payload }) => {
    const newState = structuredClone(state);
    newState.folders[payload.path] = !newState.folders[payload.path];
    return newState;
  },
  "folder/openChildren": ({ state, payload }) => {
    const newState = structuredClone(state);

    for (const key in newState.folders) {
      if (key.startsWith(payload.path)) {
        newState.folders[key] = true;
      }
    }

    newState.folders[payload.path] != newState.folders[payload.path];
    return newState;
  },
  "folder/closeChildren": ({ state, payload }) => {
    const newState = structuredClone(state);

    for (const key in newState.folders) {
      if (key.startsWith(payload.path) && key !== payload.path) {
        newState.folders[key] = false;
      }
    }

    newState.folders[payload.path] != newState.folders[payload.path];
    return newState;
  },
};

export interface useDatFolderDispatchProps {
  defaultOpen: boolean;
}
export function useDatFolderDispatch(props?: useDatFolderDispatchProps) {
  const initState = props ? { ...DefaultState, ...props } : DefaultState;
  const [state, dispatch] = useReducer(makeReducer(handlers), initState);
  return { state, dispatch };
}
